import {Component, Input, OnInit} from '@angular/core';
import {ILayoutSettings, IPageContent, IProduct} from '@app/feature/store-editor/components/layout/store-editor.interface';
import {SelectProductsComponent} from '@app/feature/store-editor/components/select-products/select-products.component';
import {MatDialog} from '@angular/material/dialog';
import { MessageService } from '@app/shared/services/common/message.service';

@Component({
  selector: 'app-featured-products-setting',
  templateUrl: './featured-products-setting.component.html',
  styleUrls: ['../styling/styling.component.css']
})
export class FeaturedProductsSettingComponent implements OnInit {

  @Input() item: IPageContent;
  @Input() storeName: string;
  @Input() layoutSetting: ILayoutSettings;
  constructor(private dialog: MatDialog, 
    private messageService: MessageService) {
  }

  ngOnInit() {
  }


  openSelectProducts() {
    const dialogRef = this.dialog.open(SelectProductsComponent, {
      data: {
        storeName: this.storeName,
        products: this.item.data.products
      }
    });

    dialogRef.afterClosed().subscribe((res: IProduct[]) => {
      if(res){
        this.item.data.products = res;        
        this.messageService.setFPCChange(true);
      }
    });
  }

}
